import { mutationProcedure } from '../trpc/common.js';
import { z } from 'zod/v4-mini';
import type { ApiParams } from '../types/ApiParams.js';
import { matchingZodObject } from '../utilities/matchingZodObject.js';

export interface ReportSpanInput {
  name: string;
  startTime: number;
  endTime: number;
  attributes?: Record<string, string | number | boolean>;
}

const ZodReportSpanInput = matchingZodObject<ReportSpanInput>({
  name: z.string(),
  startTime: z.number(),
  endTime: z.number(),
  attributes: z.optional(z.record(z.string(), z.union([z.string(), z.number(), z.boolean()]))),
});

/**
 * Report spans to the telemetry client. This is useful for reporting spans that were captured in the browser.
 */
export function reportSpan(params: ApiParams<ReportSpanInput, 'telemetryClient', 'sequence'>): void {
  const { input, ctx } = params;
  const { telemetryClient, session } = ctx;
  const { name, endTime, startTime, attributes } = input;

  telemetryClient.tracer
    .startSpan(name, {
      attributes: {
        ...attributes,
        sequence: session.sequence,
      },
      startTime,
    })
    .end(endTime);
}

// Attach a trpc procedure to the function.
reportSpan.procedure = mutationProcedure<ReportSpanInput, void>(reportSpan, ZodReportSpanInput, z.void());
